<script>
import { gsap } from 'gsap'

export default {
    name: 'SlideLines',
    data() {
        return {
            ready: false,
            emit: false,
            x: this.isMobile() ? 3 : 6
        }
    },
    computed: {
        lines() {
            let i = this.x, a = [];
            while ( i ) a.push( --i )
            return a
        }
    },
    mounted() {
        const vm = this
        const { lines } = this
        const count = this.isMobile() ? 2 : 3
        
        lines.reverse().map( x => {
            gsap.to(this.$refs[x], {
                scaleY: 1,
                duration: .75 * x,
                ease: 'expo.inOut',
                onComplete() {
                    (x + count === lines.length) && setTimeout(() => {
                        vm.$root.$emit('lines-end')
                    }, 0)
                }
            })
        })

    },
    render(h) {
        const linez = this.lines.map((el, x) => h('span', {
            class: {
                'is-visible': this.ready
            },
            ref: x,
            key: x
        }))
        return h(
            'div', {
                class: 'slide__lines'
            },
            linez
        )
    }
}
</script>
